import {Component, OnDestroy, ChangeDetectionStrategy} from '@angular/core';
import {
    NavigationCancel,
    NavigationEnd,
    NavigationError,
    NavigationStart,
    Router,
    RouterEvent,
    RouterOutlet
} from '@angular/router';
import {Subject, Subscription, takeUntil} from "rxjs";
import {AuthService} from "./_services/auth.service";
import {ToastsContainerComponent} from "./_components/toasts-container/toasts-container.component";
import {HeaderComponent} from "@app/header/header.component";
import {GlobalService} from "@app/_services/global.service";
import {ThoughtspotService} from "@app/_services/thoughtspot.service";
import {FeatureFlagService} from "@app/_services/feature-flag.service";
import {AsyncPipe} from "@angular/common";

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, ToastsContainerComponent, HeaderComponent, AsyncPipe],
    templateUrl: './app.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './app.component.scss'
})
export class AppComponent implements OnDestroy {
    private isLoggedIn$: Subscription;
    isLoggedIn: boolean = false;
    unsubscribe = new Subject<void>();

    constructor(private router: Router, private authService: AuthService, private thoughtspotService: ThoughtspotService, public globalService: GlobalService, private featureFlagService: FeatureFlagService) {
        this.globalService.showWaitOverlay();
        this.isLoggedIn$ = this.authService.isLoggedIn().subscribe({
            next: (isLoggedIn: boolean) => {
                this.isLoggedIn = isLoggedIn;

                if (this.isLoggedIn) {
                    this.thoughtspotService.getLiveboards();
                    this.featureFlagService.setEnabledFeatures();
                }
            }
        });

        this.router.events.pipe(takeUntil(this.unsubscribe)).subscribe((routerEvent) => this.checkRouterEvent(routerEvent as RouterEvent));
    }

    private checkRouterEvent(routerEvent: RouterEvent): void {
        if (routerEvent instanceof NavigationStart) {
            this.globalService.showWaitOverlay();
        }

        if (routerEvent instanceof NavigationEnd || routerEvent instanceof NavigationCancel || routerEvent instanceof NavigationError) {
            this.globalService.hideWaitOverlay();
        }
    }

    ngOnDestroy(): void {
        this.isLoggedIn$.unsubscribe();
    }
}
